import { render } from "./ActionReport.vue?vue&type=template&id=0878b563&scoped=true"
import script from "./ActionReport.vue?vue&type=script&lang=js"
export * from "./ActionReport.vue?vue&type=script&lang=js"

import "./ActionReport.vue?vue&type=style&index=0&id=0878b563&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0878b563"]])

export default __exports__